// pages/MenuManager.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import DataGrid, {
  Column,
  Editing,
  Popup,
  Paging,
  FilterRow,
  HeaderFilter,
  SearchPanel,
  Toolbar,
  Item as ToolbarItem,
  ValidationRule
} from 'devextreme-react/data-grid';
import { Form, Item } from 'devextreme-react/form';
import 'devextreme/dist/css/dx.light.css';
import API_URL from '../config';

export default function MenuManager() {
  const [menuData, setMenuData] = useState([]);
  const [loading, setLoading] = useState(false); // [추가] 로딩 상태

  useEffect(() => {
    fetchMenus();
  }, []);

  const fetchMenus = async () => {
    setLoading(true); // [추가] 조회 시작 시 로딩 상태 활성화
    try {
      const res = await axios.get(`${API_URL}/api/oracle/menu`);
      const data = res.data.map(item => ({
        ...item,
        MENU_URL: item.MENU_URL && item.MENU_URL.trim() !== "" ? item.MENU_URL : null,
        PARENT_ID: item.PARENT_ID === 0 ? null : item.PARENT_ID,
      }));
      setMenuData(data);
    } catch (err) {
      console.error("메뉴 데이터 조회 오류:", err);
      alert("메뉴 데이터를 불러오는 데 실패했습니다.");
    } finally {
      setLoading(false); // [추가] 조회 완료 시 로딩 상태 비활성화
    }
  };

  const handleRowInserted = async (e) => {
    setLoading(true);
    try {
      await axios.post(`${API_URL}/api/oracle/menu`, e.data);
    } catch (err) {
      console.error("메뉴 추가 오류:", err);
      alert("메뉴 추가에 실패했습니다: " + err.response?.data?.error);
    } finally {
      fetchMenus(); // fetchMenus가 끝나면 setLoading(false)가 호출됨
    }
  };

  const handleRowUpdated = async (e) => {
    setLoading(true);
    try {
      await axios.put(`${API_URL}/api/oracle/menu/${e.data.MENU_ID}`, e.data);
    } catch (err) {
      console.error("메뉴 수정 오류:", err);
      alert("메뉴 수정에 실패했습니다.");
    } finally {
      fetchMenus();
    }
  };

  const handleRowRemoved = async (e) => {
    setLoading(true);
    try {
      await axios.delete(`${API_URL}/api/oracle/menu/${e.data.MENU_ID}`);
    } catch (err) {
      console.error("메뉴 삭제 오류:", err);
      alert("메뉴 삭제에 실패했습니다.");
    } finally {
      fetchMenus();
    }
  };

  const handleRefresh = () => {
    fetchMenus();
  };

  return (
    <div style={{ padding: 20, height: '100%', display: 'flex', flexDirection: 'column' }}>
      <h2 style={{ marginBottom: '20px' }}>📂 메뉴 관리</h2>
      
      {/* 2. 그리드 영역 (남은 공간을 모두 차지) */}
      <div style={{ flex: 1, position: 'relative' }}> {/* [수정] position: 'relative' 추가 */}
        {/* [추가] 로딩 인디케이터 */}
        {loading && (
          <div className="loading-overlay">
            <div className="loading-spinner"></div>
            <div className="loading-text">Loading...</div>
          </div>
        )}
        <DataGrid
          dataSource={menuData}
          keyExpr="MENU_ID"
          height="100%"
          showBorders={true}
          columnAutoWidth={true}
          onRowInserted={handleRowInserted}
          onRowUpdated={handleRowUpdated}
          onRowRemoved={handleRowRemoved}
        >
          <Paging defaultPageSize={20} />
          <FilterRow visible={true} />
          <HeaderFilter visible={true} />

          <Editing
            mode="popup"
            allowUpdating={true}
            allowDeleting={true}
            allowAdding={true}
          >
            <Popup title="메뉴 정보" showTitle={true} width={1000} height={600} />
            <Form colCount={2}>
              <Item dataField="MENU_ID" >
                <ValidationRule type="required" />
              </Item>
              <Item dataField="MENU_NAME">
                <ValidationRule type="required" />
              </Item>
              <Item dataField="MENU_URL" colSpan={2} />
              <Item dataField="PARENT_ID" />
              <Item dataField="SORT_ORDER">
                <ValidationRule type="required" />
              </Item>
            </Form>
          </Editing>

          <Toolbar>
            <ToolbarItem name="addRowButton" />
            <ToolbarItem location="after">
              <SearchPanel visible={true} highlightCaseSensitive={false} />
            </ToolbarItem>
            <ToolbarItem
              location="after"
              widget="dxButton"
              options={{
                icon: "refresh",
                text: "새로고침",
                onClick: handleRefresh,
              }}
            />
          </Toolbar>

          <Column dataField="MENU_ID" caption="MENU ID" dataType="number" />
          <Column dataField="MENU_NAME" caption="메뉴명" />
          <Column dataField="MENU_URL" caption="URL" />
          <Column dataField="PARENT_ID" caption="부모 ID" dataType="number" />
          <Column dataField="SORT_ORDER" caption="정렬 순서" dataType="number" />
          <Column type="buttons" />
        </DataGrid>
      </div>
    </div>
  );
}